<template>
  <div class="auth">
    <Sign-In />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const { mapGetters: mapAuthGetters } = createNamespacedHelpers('auth')

export default {
  name: 'Auth',
  components: {
    SignIn: () => import('./SignIn'),
  },
  computed: {
    ...mapAuthGetters([
      'isValidUser',
    ]),
  },
}
</script>

<style lang="scss" scoped>
.auth {
  height: 100%;
}

@import "~src/styles/variables";

a {
  color: $color-monochrome-darkestblue;

  &:hover {
    color: $color-monochrome-white;
  }
}

.sign-in {
  background: linear-gradient(0deg, #0b3d6f 0%, $color-monochrome-nearblack 100%);
  height: 100%;
  padding: 120px 100px;

  @media screen and (min-width: $vuetify-sm-min-size) and (max-width: $vuetify-md-max-size) {
    padding: 10%;
  }

  @media screen and (max-width: $vuetify-xs-max-size) {
    padding: 10px;
  }
}

.sign-in-content {
  margin: 2rem;
  color: $color-monochrome-white;
  text-align: center;

  .sign-in-title {
    font-size: 3rem;
    font-weight: 500;
    letter-spacing: 1.71px;
    line-height: 49px;
  }

  .description {
    margin: 2rem;
    font-size: $size-large;
    font-weight: 500;
    letter-spacing: 0.86px;
    line-height: 25px;
  }

  button {
    border-radius: 6px;
    background-color: white;
    color: $color-vibrant-blue;
    width: 250px;
    font-size: $size-large;
    font-weight: bold;
    letter-spacing: 0.86px;
    line-height: 25px;
  }

  .need-help {
    h2 {
      text-align: left;
    }
  }

  .need-help-activator {
    text-transform: uppercase;
  }

  .error-label {
    border-radius: 6px;
    letter-spacing: 0.05ch;
  }
}
</style>
